/**
 * Seitenbilder für die Dokumentansicht (`DokumentLightbox`).
 *
 * Der Server rendert PDF-Seiten als JPEG (`kontor_seitenbild`) — kein pdf.js
 * im Bundle, und ein `<img>` sieht auf jedem Gerät gleich aus.
 */

/**
 * Wie breit eine Seite gerendert werden soll, in Pixeln.
 *
 * Bildschirmbreite × Pixeldichte × 2 — die Lightbox kann auf doppelte Breite
 * vergrößern, und dann soll das Kleingedruckte noch scharf sein. Auf dem
 * iPhone (390 × 3) sind das 2340 px, am Rechner (≥ 900 px Blatt × 1) 1800.
 */
export function bildBreite(): number {
  if (typeof window === "undefined") return 1400;
  const blatt = Math.min(window.innerWidth || 900, 900);
  const dichte = Math.min(window.devicePixelRatio || 1, 3);
  return Math.max(800, Math.min(2400, Math.round((blatt * dichte * 2) / 100) * 100));
}

/**
 * Ein PDF, das nur im Browser liegt (Editor-Vorschau, Lieferschein), als
 * Seitenbilder. Die Datei geht einmal zum Server und kommt als data-URLs
 * zurück; eine feste Adresse, die man Seite für Seite abrufen könnte, hat sie
 * nicht.
 */
export async function seitenbilderAus(pdf: Blob): Promise<string[]> {
  // Etwas kleiner als bildBreite(): alle Seiten kommen in einer Antwort.
  const breite = Math.min(bildBreite(), 1800);
  const antwort = await fetch(`/api/kontor/dokument/seitenbilder?w=${breite}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/pdf" },
    body: pdf,
  });
  if (!antwort.ok) {
    let meldung = `Die Vorschau konnte nicht erzeugt werden (${antwort.status}).`;
    try {
      const body = await antwort.json() as { detail?: string };
      if (body.detail) meldung = body.detail;
    } catch { /* Textmeldung bleibt. */ }
    throw new Error(meldung);
  }
  return ((await antwort.json()) as { seiten: string[] }).seiten;
}
